import React, { useState } from "react";
import { HeadingXL } from "../../atoms/HeadingXL";
import { Text } from "../../atoms/Text";
import { HolderContent } from "../../atoms/HolderContent";
import { Anchor } from "../../atoms/Anchor";
import { motion, AnimatePresence } from "framer-motion";
export function HomeText({ title, description, color, link , linkDesc}) {
  const [showArrow, setShowArrow] = useState(false);
  return (
    <div className="col-12 col-lg-7 h-100 d-flex flex-column justify-content-center align-items-start">
      <HeadingXL color="white">{title}</HeadingXL>
      <Text fs="24px" fsMobile="22px" className="text-white mt-5 mb-0">
        {description}
      </Text>
 
        
        <Anchor
        to={link}
        onMouseEnter={() => setShowArrow(true)}
        onMouseLeave={() => setShowArrow(false)}
        fw="500"
        underline={false}
        className={`bg-${color} d-inline-flex align-items-center text-white btn px-5 mt-5`}
        h="48px"
        fs="16px"
      >
        {linkDesc}
             <AnimatePresence>
          {showArrow && (
            <motion.div inial={{width:0}}
            animate={{width:16}}
            exit={{width:0}}
              transition={{duration:0.5, type:'smooth'}}></motion.div>)}</AnimatePresence>
            <AnimatePresence>{showArrow && (<motion.svg
              transition={{duration:0.5, type:'smooth'}}
              initial={{ opacity: 0, x: -10 ,width:0,margin:0}}
              animate={{ opacity: 1, x: 0 ,width:18, marginLeft: 100}}
              exit={{ opacity: 0, x: -10 ,width:0, margin: 0}}
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403806 11.9896 0.403806 11.6967 0.696699C11.4038 0.989593 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75H17V5.25H1V6.75Z"
                fill="white"
              />
            </motion.svg>   
          )}</AnimatePresence>

      </Anchor>     
    </div>
  );
}
